<script setup>
import { storeToRefs } from 'pinia';
import { trans } from '@elements/translation';
import Button from '@atoms/components/Button.vue';
import { useDataTableStore } from '@stores/useDataTableStore';
import { flashBagSuccess } from '@tools/flashbag';
import { useInvoiceModalStore } from '@organisms/ubiq-administration/store/invoiceModal';
import { useInvoiceStore } from '@organisms/ubiq-administration/store/invoices';
import BillingDocumentSummaryCard from './cards/BillingDocumentSummaryCard.vue';

const emit = defineEmits([ 'close' ]);

const datatableStore = useDataTableStore();

const modalStore = useInvoiceModalStore();
const { details } = storeToRefs(modalStore);
const { type, status } = details.value;

const invoiceStore = useInvoiceStore();
const { updateInvoiceStatus } = invoiceStore;
const { selectedInvoice } = storeToRefs(invoiceStore);

const onValidate = async () => {
  const data = await updateInvoiceStatus(type, selectedInvoice.value.id, status);

  datatableStore.updateDataById(selectedInvoice.value.row_id, data[type]);

  flashBagSuccess(
    trans(`gestion.invoices.slider.${type}.${status}.success`),
  );

  emit('close');
};
</script>

<template>
  <div class="slider-credit-note">
    <div class="slider-credit-note__content">
      {{ trans(`gestion.invoices.slider.description.${type}.${status}`) }}

      <BillingDocumentSummaryCard :invoice="selectedInvoice" />
    </div>
    <div class="slider-credit-note__footer">
      <div class="slider-credit-note__footer-buttons">
        <Button variant="secondary" class="btn" @click="emit('close')">
          {{ trans('gestion.invoices.slider.credit_note.ctas.cancel') }}
        </Button>
        <Button
          variant="primary"
          :class="{ 'loading-btn': invoiceStore.isLoading() }"
          :disabled="invoiceStore.isLoading()"
          @click="onValidate"
        >
          {{ trans('gestion.invoices.slider.mark.ctas.confirm') }}
        </Button>
      </div>
    </div>
  </div>
</template>
